import PricingCard from '../../../components/organisms/PricingCard/PricingCard';
import React, { Component } from 'react';

import './styles.css';

/**
 * Description
 * @typedef {Object} Props
 * @prop {Object} content
 */

export default class Pricing extends Component {
	genCards = (plans = []) =>
		plans.map((plan) => <PricingCard key={plan.id} plan={plan} />);

	render () {
		const { plans } = this.props.content.pricing;

		return (
			<div className='PricingCards'>
				<div className='PricingCards-cards'>
					<div className='PricingCards-row'>
						{this.genCards(plans)}
					</div>
				</div>
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/components/templates/Pricing/Pricing.js